export const LOAD_CLAIM_LIST = 'fastcover.LOAD_CLAIM_LIST';
export const CREATE_NEW_CLAIM = 'fastcover.CREATE_NEW_CLAIM';
export const CREATE_NEW_CLAIM_SUCCESS = 'fastcover.CREATE_NEW_CLAIM_SUCCESS';
export const LOAD_CLAIM_LIST_SUCCESS = 'fastcover.LOAD_CLAIM_LIST_SUCCESS';
export const LOAD_CLAIM_LIST_ERROR = 'fastcover.LOAD_CLAIM_LIST_ERROR';
export const UPDATE_SELECTED_CLAIM_ID = 'fastcover.UPDATE_SELECTED_CLAIM_ID';
export const UPDATE_SELECTED_CLAIM_NUMBER = 'fastcover.UPDATE_SELECTED_CLAIM_NUMBER';
export const UPDATE_SELECTED_CLAIM_NUMBERS = 'fastcover.UPDATE_SELECTED_CLAIM_NUMBERS';
export const PRE_LOAD_CLAIM = 'fastcover.PRE_LOAD_CLAIM';
export const LOAD_CLAIM = 'fastcover.LOAD_CLAIM';
export const LOAD_CLAIM_SUCCESS = 'fastcover.LOAD_EXISTING_CLAIM_SUCCESS';
export const LOAD_CLAIM_TYPE = 'fastcover.LOAD_CLAIM_TYPE';
export const LOAD_CLAIM_TYPE_SUCCESS = 'fastcover.LOAD_CLAIM_TYPE_SUCCESS';
export const LOAD_CLIENT_INFO = 'fastcover.LOAD_CLIENT_INFO';
export const LOAD_CLIENT_INFO_SUCCESS = 'fastcover.LOAD_CLIENT_INFO_SUCCESS';
export const LOADING_BUTTON = 'fastcover.LOADING_BUTTON';
export const LOAD_CLAIM_FROM_SUMMARY = 'fastcover.LOAD_CLAIM_FROM_SUMMARY';
export const UPLOAD_CLAIM_SUMMARY = 'fastcover.UPLOAD_CLAIM_SUMMARY';
export const DOWNLOAD_SUMMARY = 'fastcover.DOWNLOAD_SUMMARY';
export const GET_TITLE_LIST = 'fastcover.GET_TITLE_LIST';
export const GET_TITLE_LIST_SUCCESS = 'fastcover.GET_TITLE_LIST_SUCCESS';
export const GET_SHOW_ELECTRONIC_CONSENT = 'fastcover.GET_SHOW_ELECTRONIC_CONSENT';
export const GET_DEPRECIATION_TYPE_LIST = 'fastcover.GET_DEPRECIATION_TYPE_LIST';
export const GET_DEPRECIATION_TYPE_LIST_SUCCESS = 'fastcover.GET_DEPRECIATION_TYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./app/containers/ClaimList/constants.js